import { Trans, useTranslation } from 'react-i18next'
import { Link } from 'react-router-dom'
import { Button } from '@dorixona/ui'
import { Field } from './ui/Field'
import { PhoneField } from './ui/PhoneField'
import { isCompletePhone } from './model'
import { AuthHero } from './AuthHero'

export interface PhoneStepProps {
  phone: string
  onPhoneChange: (digits: string) => void
  onSubmit: () => void
  pending: boolean
  error: string | undefined
  /** В мини-аппе: взять номер из Telegram — без кода. */
  onShareContact?: () => void
  sharing?: boolean
}

export function PhoneStep({
  phone,
  onPhoneChange,
  onSubmit,
  pending,
  error,
  onShareContact,
  sharing = false,
}: PhoneStepProps) {
  const { t } = useTranslation('auth')
  const ready = isCompletePhone(phone)

  return (
    <>
      <AuthHero title={t('phone.title')} subtitle={t('phone.subtitle')} withLogo />
      <Field label={t('phone.label')} error={error}>
        {({ id, describedBy }) => (
          <PhoneField
            id={id}
            describedBy={describedBy}
            value={phone}
            placeholder={t('phone.placeholder')}
            onChange={onPhoneChange}
            onSubmit={onSubmit}
            // См. PhoneField: клавиатура открывается сразу.
            // eslint-disable-next-line jsx-a11y/no-autofocus
            autoFocus
          />
        )}
      </Field>
      <Button loading={pending && !sharing} disabled={!ready || sharing} onPress={onSubmit}>
        {t('phone.submit')}
      </Button>
      {onShareContact ? (
        <Button
          variant="ghost"
          className="auth-share"
          loading={sharing}
          disabled={pending}
          onPress={onShareContact}
        >
          {sharing ? t('telegram.sharing') : t('telegram.share')}
        </Button>
      ) : null}
      <p className="auth-note">
        <Trans
          i18nKey="auth:phone.terms"
          components={{ privacy: <Link className="auth-link" to="/privacy-policy" /> }}
        />
      </p>
    </>
  )
}
